import { reactive } from 'vue'
import Api from '@/config/api.helper.js'
import { useSessionStore } from '@/stores/components/sessionStore'

const state = reactive({
  loading: false,
  returno: null,
})

export default {
  install: (app) => {
    app.config.globalProperties.$planosEmpresa = () => {
      const sessionStore = useSessionStore()

      const updatePlanos = async (formData) => {
        state.loading = true
        await Api.post('planos/editar', formData)
          .then((response) => {
            const payload = response.data?.data

            if (payload != null && sessionStore.userData) {
              const plano =
                typeof payload === 'string' ? JSON.parse(payload) : payload

              sessionStore.setUserData({
                plano: {
                  ...sessionStore.userData.plano,
                  pla_descricao: plano.pla_descricao,
                  pla_gerar_bonus: plano.pla_gerar_bonus,
                  pla_minimo_recarga: plano.pla_minimo_recarga,
                  pla_tipo_valor_bonus: plano.pla_tipo_valor_bonus,
                  pla_valor_bonus: plano.pla_valor_bonus,
                  uuid_pla_id: plano.uuid_pla_id,
                },
                empresasDisponiveis: sessionStore.userData.empresasDisponiveis,
                permissoes: sessionStore.userData.permissoes,
                modulos: sessionStore.userData.modulos,
                saldo: sessionStore.userData.saldo,
                notificacoesEmpresa: sessionStore.userData.notificacoesEmpresa,
                onboarding: sessionStore.userData.onboarding || [],
              })
            }

            state.returno = {
              msg: 'Plano salvo com sucesso!',
              status: true,
            }
          })
          .catch((error) => {
            state.returno = {
              msg: error ? error : 'Ocorreu um erro ao salvar o plano',
              status: false,
            }
          })
        state.loading = false
      }
      return {
        user: sessionStore.userData,
        updatePlanos,
        loading: state.loading,
        returno: state.returno,
      }
    }
  },
}
